import { render, staticRenderFns } from "./WizardAddPhone.vue?vue&type=template&id=5fb097c0&scoped=true&"
import script from "./WizardAddPhone.vue?vue&type=script&lang=js&"
export * from "./WizardAddPhone.vue?vue&type=script&lang=js&"
import style0 from "./WizardAddPhone.vue?vue&type=style&index=0&id=5fb097c0&prod&lang=css&"
import style1 from "./WizardAddPhone.vue?vue&type=style&index=1&id=5fb097c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb097c0",
  null
  
)

export default component.exports